import React, { useState, useEffect } from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";

import fontStyles from "../../../fonts";
import ImageComponent from "../../common/ImageComponent";
import CheckElementIcon from "../../common/icons/CheckElementIcon";
import AddElement from "./AddElement";
import QuickElementCreationDialog from "./QuickElementCreationDialog";
import { isWeb } from "../../../../helpers/utils";

export default function ChipsList({
  elements = [],
  parentId = null,
  selection = null,
  controller,
  updateSelectedElements = () => {},
}) {
  const [selectedChips] = useState(
    new Set(selection ? JSON.parse(selection) : []),
  );
  const [elementsList, setElementsList] = useState(elements);
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    elementsList.forEach((e) => (e.isSelected = selectedChips.has(e.id)));
    setElementsList(elements);
  }, [elements]);

  const onItemSelected = (element) => {
    element.isSelected = !element.isSelected;

    if (element.isSelected) {
      selectedChips.add(element.id);
    } else {
      selectedChips.delete(element.id);
    }

    updateSelectedElements(Array.from(selectedChips));
  };

  const createElement = (element) => {
    const elementModel = {
      ...element,
      edit_id: "",
      edit_is_active: "checked",
      parents: [parentId],
    };

    setShowDialog(false);

    controller.apiService
      .cardAction({
        action: "save",
        target: "element",
        ...elementModel,
      })
      .then((response) => {
        if (response.id) {
          const newElement = {
            ...element,
            name: element.edit_name,
            id: response.id,
            icon: element.edit_icon,
            parent_id: parentId,
          };

          // Refresh elements list
          setElementsList([...elementsList, newElement]);

          // 08.11.2021 Preselect newly created elements
          onItemSelected(newElement);
        }
      });
  };

  return (
    <>
      <View style={styles.container}>
        <View style={styles.elementsContainer}>
          {elementsList.map((el, index) => (
            <TouchableOpacity
              key={index}
              style={[styles.chip, el.isSelected ? styles.chipSelected : {}]}
              onPress={() => onItemSelected(el)}
            >
              {el.icon && el.icon.length > 0 ? (
                <ImageComponent styles={styles.icon} icon={el.icon} />
              ) : (
                <ImageComponent
                  image={require("../../../../assets/customize/tagIcon.png")}
                  styles={styles.icon}
                />
              )}

              <Text
                numberOfLines={2}
                style={[fontStyles.h5medium, styles.text]}
              >
                {el.name}
              </Text>
              <CheckElementIcon isSelected={el.isSelected} />
            </TouchableOpacity>
          ))}
        </View>

        <View
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 16,
          }}
        >
          <AddElement
            onPress={() => setShowDialog(true)}
            style={{
              backgroundColor: "#F3F2F1",
            }}
          />
        </View>
      </View>

      {showDialog ? (
        <QuickElementCreationDialog
          createElement={createElement}
          close={() => setShowDialog(false)}
        />
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    marginTop: 16,
    marginBottom: 90,
    width: "100%",
  },
  elementsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    flexWrap: "wrap",
    width: "100%",
  },
  icon: {
    width: 20,
    height: 20,
    marginRight: 5,
  },
  chip: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: 34,
    width: "auto",
    minWidth: isWeb ? 117 : 155,
    marginRight: 6,
    marginBottom: 6,
    paddingVertical: 2,
    paddingHorizontal: 6,
    borderRadius: 100,
    backgroundColor: "#F3F2F1",
  },
  chipSelected: {
    backgroundColor: "#F6EC91",
  },
  text: {
    flex: 1,
    paddingRight: 6,
  },
});
